export default __webpack_public_path__ + "static/media/1Loop.e39afbbb.mp4";